import React, { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import AnimateHeight from "react-animate-height";
import * as S from "./PermInfo.sc";
import { fetchApi } from "../../services/requests";
import { Flex } from "../../styled/Styled.sc";

const PermInfo = ({ short, extended }) => {
  const [height, setHeight] = useState('auto');

  return (
    <>
      <S.Text>{ReactHtmlParser(short)}</S.Text>
      <AnimateHeight duration={500} height={height}>
        <S.Text>{ReactHtmlParser(extended)}</S.Text>
      </AnimateHeight>
      <Flex justifyContent="flex-end" alignItems="flex-start">
        <S.TextBtn onClick={() => setHeight(height === "auto" ? 0 : "auto")}>
          {/* {height === "auto" ? "Zwiń" : "Rozwiń"} */}
        </S.TextBtn>
      </Flex>
    </>
  );
};

export default PermInfo;
